import { Item } from './item';
import { PercentagesWrapper } from './style';

import type React from 'react';
import type { PercentageInfo } from '../types';

type Props = {
  data: PercentageInfo[];
};

export const Percentages: React.FC<Props> = ({ data }) => (
  <PercentagesWrapper>
    {data.map((item, index) => (
      <Item key={index} label={item.label} value={item.value} />
    ))}
  </PercentagesWrapper>
);
